import { useEffect, useState } from 'react';
import { getShop } from '../../api/sparksApi';

// One shop fetch per child per page load, shared by every Addy on screen (lesson, quiz, Core Skills) and the nav's
// shop count. The shop page hands its fresh payload over (primeShop) so a purchase reaches them without a refetch.
const requests = new Map();
const listeners = new Set();
const NO_ITEMS = [];

function shopFor(childId) {
  if (!requests.has(childId)) {
    requests.set(childId, getShop(childId).catch(() => {
      requests.delete(childId); // retry on the next mount
      return null;
    }));
  }
  return requests.get(childId);
}

/** Replaces the cached shop for `childId` and updates every mounted hook. */
export function primeShop(childId, shop) {
  if (!childId || !shop) return;
  requests.set(childId, Promise.resolve(shop));
  listeners.forEach((l) => l(childId, shop));
}

/** The child's shop payload ({ enabled, canBuy, balance, items }), or null until it loads. */
export function useShop(childId) {
  const [shop, setShop] = useState(null);
  useEffect(() => {
    setShop(null);
    if (!childId) return undefined;
    let cancelled = false;
    shopFor(childId).then((s) => { if (!cancelled) setShop(s); });
    const onPrime = (id, s) => { if (id === childId) setShop(s); };
    listeners.add(onPrime);
    return () => {
      cancelled = true;
      listeners.delete(onPrime);
    };
  }, [childId]);
  return shop;
}

/** Catalogue rows that resolve the child's equipped item keys to the rig's pictures and celebration clip. */
export default function useCosmeticCatalogue(childId) {
  return useShop(childId)?.items || NO_ITEMS;
}
